import {
    Circle,
    HStack,
    IconButton,
    Button,
    VStack,
    Spinner,
    useBoolean
  } from '@chakra-ui/react';
import AppColors from '../../../../constants/AppColors';
import { EditIcon,
} from '../../../../constants/IconData';
import { SmallCloseIcon } from '@chakra-ui/icons';
import SubmitModal from '../../forms/SubmitModal'

const ActivationComponent = ({
    label, 
    editingKey,
    is_active,
    isUpdating,
    setEditingKey,
    handlePartialInfoUpdate
}) => {

    const [accountActivationModal, aamState] = useBoolean(false);

    return (
        (
            <>
              <HStack width={'100%'} justifyContent="space-between" padding={1}>
              <>
                <Button
                  outline={`2px solid ${AppColors.secondary}`}
                  color={AppColors.primary}
                  _hover={{
                    transition: 'all .1s ease',
                    bgColor: AppColors.white,
                    color: AppColors.secondary,
                  }}
                  // bgColor={AppColors.secondary}
                  bgColor={is_active ? AppColors.red : AppColors.green}
                  textColor={'#fff'}
                  _disabled={{
                    bgColor: editingKey != label ? '#e6e6e6' : (is_active ? AppColors.red : AppColors.green),
                    textColor: editingKey != label ? '#6d747e' : '#fff',
                    cursor: 'not-allowed'
                  }}
                  disabled={editingKey != label || isUpdating}
                  size={'sm'}
                  px={12}
                  rounded={'full'}
                  onClick={() => {
                    aamState.on();
                  }}
                >
                  {(editingKey == label && isUpdating) ? (
                      is_active ? ('DEACTIVATING') : ('ACTIVATING')
                    ): (
                    is_active ? ('DEACTIVATE') : ('ACTIVATE'))}
                </Button>
                {(editingKey == label && isUpdating) && (
                  <VStack justify="center" align="center">
                    <Spinner/>
                  </VStack>
                )}
              </>
                {editingKey !== label && label !== 'specialty' ? (
                      <Circle
                        size="40px"
                        bg={AppColors.gray}
                        onClick={() => setEditingKey(label)}
                        cursor={'pointer'}
                      >
                        <EditIcon />
                      </Circle>
                    ) : (!isUpdating && (
                    <IconButton
                          borderRadius={'full'}
                          p={1}
                          bg={'white'}
                          borderWidth={1}
                          borderColor={AppColors.gray}
                          icon={<SmallCloseIcon color={'black'} boxSize={3} />}
                          onClick={() => {
                            setEditingKey(null);
                          }}
                        />))
                  }
              </HStack>
              <SubmitModal
                isOpen={accountActivationModal}
                onClose={() => {
                  aamState.off();
                  setEditingKey(null);
                }}
                cancelMsg='No, Cancel'
                confirmMsg={is_active ? 'YES DEACTIVATE' : 'YES ACTIVATE'}
                handleConfirmation={async (allClients) => {
                  aamState.off();
                  let payload = {attribute: 'is_active', is_active: !is_active};
                  if (allClients) {
                    payload['all_clients'] = true;
                  }
                  await handlePartialInfoUpdate(payload, false, true);
                  setEditingKey(null);
                }}
                checkBoxMsg={(is_active ? 'Deactivate ' : 'Activate ') +'all subclients.'}
                confirmationMsg={'Are you sure to ' + (is_active ? 'deactivate ' : 'activate ') + 'this account ?'}
                confirmationWarning={'This will effect all the sub clients under this client'}
                isActivation={true}
                isChecked={is_active}
              />
            </>
          )

    );


}


export default ActivationComponent;